/** Site-wide SEO constants – used by index.html copy and the Seo component */

export const SITE_URL = 'https://psagchurch.org';

export const SITE_NAME = 'PSAG Church';
export const SITE_LEGAL_NAME = 'Philadelphia Shalem Assembly of God';

export const OG_IMAGE = `${SITE_URL}/og-image.jpg`;
export const OG_IMAGE_ALT = 'PSAG Church';
export const SHARE_TITLE = 'PSAG Church';
export const SHARE_DESCRIPTION = 'Worship · Prayer · Fellowship';

export const DEFAULT_DESCRIPTION =
  'PSAG Church (Philadelphia Shalem Assembly of God) is a Malayalee-English Pentecostal church in Philadelphia, PA. Join us for worship, prayer, and fellowship. Service times, sermons, and visit info online.';

export const DEFAULT_META = {
  title: 'PSAG Church | Philadelphia Shalem Assembly of God',
  description: DEFAULT_DESCRIPTION,
};

export const ROUTE_META = {
  '/': DEFAULT_META,
  '/new-here': {
    title: 'New Here | PSAG Church – Philadelphia',
    description:
      'New to PSAG Church? Learn what to expect at Philadelphia Shalem Assembly of God, service times, and how to connect with our church family.',
  },
  '/visit-us': {
    title: 'Plan Your Visit | PSAG Church – Philadelphia, PA',
    description:
      'Visit PSAG Church at 2840 Holme Ave, Philadelphia PA 19152. Service times, directions, contact info, and upcoming events.',
  },
  '/story': {
    title: 'Our Story | PSAG Church – Philadelphia Shalem Assembly of God',
    description:
      'The story of Philadelphia Shalem Assembly of God (PSAG Church), founded in 2014 and serving the Malayalee Pentecostal community in Philadelphia.',
  },
  '/beliefs': {
    title: 'Our Beliefs & Values | PSAG Church',
    description:
      'What we believe at PSAG Church — Philadelphia Shalem Assembly of God. Our faith, values, and biblical foundations as an Assemblies of God congregation.',
  },
  '/ministries': {
    title: 'Ministries | PSAG Church – Philadelphia',
    description:
      'Explore ministries at PSAG Church including youth, outreach, prayer, and community programs at Philadelphia Shalem Assembly of God.',
  },
  '/watch': {
    title: 'Watch Sermons & Live Streams | PSAG Church',
    description:
      'Watch Sunday services, messages, and church events from PSAG Church on YouTube. Philadelphia Shalem Assembly of God live streams and sermons.',
  },
  '/gallery': {
    title: 'Photo Gallery | PSAG Church – Philadelphia',
    description:
      'Photos from worship, events, and community life at PSAG Church (Philadelphia Shalem Assembly of God).',
  },
};

export const CHURCH_SAME_AS = [
  'https://www.facebook.com/psagchurch',
  'https://www.youtube.com/@psagchurch',
  'https://www.instagram.com/psagchurch/',
];

export const CHURCH_JSON_LD = {
  '@context': 'https://schema.org',
  '@type': 'Church',
  '@id': `${SITE_URL}/#church`,
  name: SITE_LEGAL_NAME,
  alternateName: ['PSAG Church', 'PSAG', 'Philadelphia Shalem Assembly of God Church'],
  url: SITE_URL,
  logo: `${SITE_URL}/web-app-manifest-512x512.png`,
  image: OG_IMAGE,
  description: DEFAULT_DESCRIPTION,
  telephone: '+1-267-984-3132',
  email: 'philadelphiashalemag@gmail.com',
  foundingDate: '2014',
  founder: {
    '@type': 'Person',
    name: 'Sajan George',
    jobTitle: 'Pastor',
  },
  employee: [
    {
      '@type': 'Person',
      name: 'Sajan George',
      jobTitle: 'Senior Pastor',
    },
  ],
  parentOrganization: {
    '@type': 'Organization',
    name: 'Assemblies of God USA',
    url: 'https://ag.org',
  },
  contactPoint: {
    '@type': 'ContactPoint',
    telephone: '+1-267-984-3132',
    email: 'philadelphiashalemag@gmail.com',
    contactType: 'customer service',
    availableLanguage: ['English', 'Malayalam'],
  },
  address: {
    '@type': 'PostalAddress',
    streetAddress: '2840 Holme Ave',
    addressLocality: 'Philadelphia',
    addressRegion: 'PA',
    postalCode: '19152',
    addressCountry: 'US',
  },
  geo: {
    '@type': 'GeoCoordinates',
    latitude: 40.0512788,
    longitude: -75.0301847,
  },
  sameAs: CHURCH_SAME_AS,
  openingHoursSpecification: [
    {
      '@type': 'OpeningHoursSpecification',
      dayOfWeek: 'Friday',
      opens: '19:30',
      closes: '21:00',
    },
    {
      '@type': 'OpeningHoursSpecification',
      dayOfWeek: 'Saturday',
      opens: '18:30',
      closes: '20:00',
    },
    {
      '@type': 'OpeningHoursSpecification',
      dayOfWeek: 'Sunday',
      opens: '09:00',
      closes: '12:00',
    },
  ],
};
